module.exports = __webpack_public_path__ + "img/emoji_active.ddb132cd.svg";